import { defineComponent as u, computed as t, createElementBlock as d, openBlock as m, normalizeClass as f, toDisplayString as b } from "vue";
import { isEmpty as g } from "../../utils/isEmpty.js";
import { tw as a } from "../../utils/tailwind.js";
const v = ["aria-label", "aria-labelledby"], y = /* @__PURE__ */ u({
  name: "RevBadge",
  __name: "Badge",
  props: {
    ariaLabel: { default: () => {
    } },
    ariaLabelledby: { default: () => {
    } },
    count: { default: 0 },
    maxCount: { default: 99 },
    size: { default: "large" },
    variant: { default: "info" }
  },
  setup(e) {
    const i = t(() => e.count === 0 ? null : e.count > e.maxCount ? `${e.maxCount}+` : e.count), s = t(() => !g(i.value)), o = t(() => {
      const n = a`text-static-default-hi rounded-lg caption-bold inline-block max-w-full truncate`, l = a`min-w-20 px-4 text-center`, c = {
        small: a`size-6`,
        medium: a`size-8`,
        large: a`size-12`
      }, r = {
        danger: a`bg-static-danger-hi`,
        warning: a`bg-static-warning-hi`,
        success: a`bg-static-success-hi`,
        info: a`bg-static-info-hi`,
        accent: a`bg-static-info-max`
      };
      return [
        n,
        r[e.variant],
        s.value ? l : c[e.size]
      ];
    });
    return (n, l) => (m(), d("span", {
      "aria-label": e.ariaLabel,
      "aria-labelledby": e.ariaLabelledby,
      "aria-live": "polite",
      class: f(o.value),
      role: "status"
    }, b(i.value), 11, v));
  }
});
export {
  y as default
};
